/* Aarna — Meta AddToCart tracking bridge REMOVED 2026-07-24.
   Reason: it fired a second fbq('AddToCart') on every AJAX /cart/add.js call,
   on top of Shopify's native Meta pixel (which already tracks AddToCart on AJAX
   carts). The two used different event IDs, so Meta could not deduplicate them
   and AddToCart was counted ~2x. Removing the bridge leaves ONE AddToCart source
   (Shopify's native Meta pixel). The country/currency selector below is kept.
   To restore the bridge, revert this file from the 'Aarnalab backup' theme. */

/* Searchable country/currency selector. Kept in a globally loaded asset so it also works on the Aarna PDP. */
(function () {
  'use strict';

  if (window.__PK_SEARCHABLE_LOCALIZATION__) return;
  window.__PK_SEARCHABLE_LOCALIZATION__ = true;

  function normalize(value) {
    return (value || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  }

  var currencyCountries = {
    usd: ['united states'],
    'us dollar': ['united states'],
    cad: ['canada'],
    'canadian dollar': ['canada'],
    gbp: ['united kingdom'],
    pound: ['united kingdom'],
    aud: ['australia'],
    'australian dollar': ['australia'],
    eur: ['france', 'germany', 'italy', 'spain', 'netherlands', 'ireland', 'portugal', 'belgium', 'austria'],
    euro: ['france', 'germany', 'italy', 'spain', 'netherlands', 'ireland', 'portugal', 'belgium', 'austria']
  };

  function initializeSearch() {
    document.querySelectorAll('.pk-locale').forEach(function (locale, index) {
      var list = locale.querySelector('.pk-locale__list');
      if (!list || locale.querySelector('.pk-locale-search')) return;

      var id = 'PkLocaleSearch-' + index;
      var label = document.createElement('label');
      label.className = 'pk-locale-search__label';
      label.htmlFor = id;
      label.textContent = 'Search country or currency';

      var input = document.createElement('input');
      input.id = id;
      input.className = 'pk-locale-search';
      input.type = 'search';
      input.autocomplete = 'off';
      input.placeholder = 'Search country or currency';
      input.setAttribute('aria-label', 'Search country or currency');

      var empty = document.createElement('div');
      empty.className = 'pk-locale-search__empty';
      empty.hidden = true;
      empty.textContent = 'No matching country or currency found.';

      list.parentNode.insertBefore(label, list);
      list.parentNode.insertBefore(input, list);
      list.parentNode.insertBefore(empty, list);

      function filterOptions() {
        var query = normalize(input.value).replace(/\s+/g, ' ');
        var countries = currencyCountries[query] || null;
        var visible = 0;

        list.querySelectorAll('li').forEach(function (item) {
          var button = item.querySelector('.pk-locale__option');
          var row = normalize(item.textContent);
          var value = button ? normalize(button.value) : '';
          var match = !query || row.indexOf(query) !== -1 || value.indexOf(query) !== -1;

          if (countries) {
            match = countries.some(function (country) {
              return row.indexOf(country) !== -1 || value.indexOf(country) !== -1;
            });
          }

          item.hidden = !match;
          if (match) visible += 1;
        });

        empty.hidden = visible !== 0;
      }

      input.addEventListener('input', filterOptions);
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') locale.removeAttribute('open');
      });

      locale.addEventListener('toggle', function () {
        if (locale.open) {
          window.setTimeout(function () {
            input.focus();
            input.select();
          }, 80);
        } else {
          input.value = '';
          filterOptions();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSearch, { once: true });
  } else {
    initializeSearch();
  }

  document.addEventListener('shopify:section:load', initializeSearch);
})();
